// extracted by mini-css-extract-plugin
export default {"container":"Top_slider_container__05Zl9","sliderVideo":"Top_slider_sliderVideo__MSCsh","topSlider":"Top_slider_topSlider__Rnds9"};